import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './plansetup.module.scss';
import { ExpandMore } from '@mui/icons-material';
import { Button, Chip } from '@mui/material';
import FilterData from './FilterData';
import CustomTabPanel from '../../../components/commonComponent/CustomTabPanel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { format } from 'date-fns';

interface PlanProps {
  handleClick: () => void;
  handleFilterChange: () => void;
}


const PlanSetup: React.FC<PlanProps> = ({ handleClick, handleFilterChange }) => {
  const [value, setValue] = useState(0);
  const [expanded, setExpanded] = useState<boolean>(true);
  const { dayparts } = useSelector((state: RootState) => state.productionPlan);
  const { params, reasons } = useSelector((state: RootState) => state.updateProductionPlan);
  const { dishes } = useSelector((state: RootState) => state.getCategory); 
  const menuDate = params ? format(new Date(params.menudate), 'dd MMM yyyy') : 'No Date';
  const selectedDayParts = params ? dayparts?.filter(daypart => params?.daypartid?.includes(daypart.id)) : [];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleToggleChange = () => {
    setExpanded(!expanded);
  };
  return (
    <div className='white-box mb-12'>
      <div
        className={`flex justify-content-between align-items-center ${expanded ? styles.tabbingDataWrap : styles.tabbingDataWrapMinimize
          }`}
      >
        {expanded ? (
          <Tabs value={value} onChange={handleChange} aria-label="Tabs" className={!expanded ? 'tabs-wrapper colapsed' : 'tabs-wrapper'}>
            <Tab label="Filter" id={`simple-tabpanel-${0}`} aria-labelledby={`simple-tab-${0}`} disableRipple />
          </Tabs>
        ) : (
          <div className='flex align-items-center'>
            <div className={styles.dateRange}>
              <span className={styles.dateLabel}>Date:</span>
              <span className={styles.date}>{menuDate}</span>
            </div>
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>Mealtime:</span>
              {params ? (
                  <span className={styles.chipData}>
                    {selectedDayParts?.map((daypart: any, index) => (
                      <Chip
                        key={index}
                        label={`${daypart?.name}`}
                        className={styles.chip}
                      />
                    ))}
                  </span>
                ) : (
                  <span className={styles.chipData}>--</span>
                )}
            </div>            
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>From Dish:</span>
              <span className={styles.chipData}>
                {params ? dishes?.find((dish:any)=>dish?.dishid==params?.fromdish)?.dishname : "--"}
              </span>
            </div>            
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>To Dish:</span>
              <span className={styles.chipData}>
                {params ? dishes?.find((dish:any)=>dish?.dishid==params?.todish)?.dishname : "--"}
              </span>
            </div>            
            <div className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}>
              <span className={styles.dateLabel}>Reason:</span>
              <span className={styles.chipData}>
                {params ?  reasons?.find((reason:any)=>reason?.reasoncode==params?.reasonid)?.reasondescription : "--"}
              </span>
            </div>            
          </div>
        )}
        <Button
          onClick={handleToggleChange}
          className={`expend-btn ${expanded && 'active'}`}
          disableRipple
        >
          {expanded ? 'Minimize Section' : 'Expand'}
          <span>
            <ExpandMore />
          </span>
        </Button>
      </div>
      <div className={`inner-contant ${!expanded && 'd-none'}`}>
        <CustomTabPanel value={value} index={0}>
          <FilterData handleClick={handleClick} handleMenuChange={handleToggleChange} handleFilterChange={handleFilterChange}/>
        </CustomTabPanel>
      </div>
    </div>
  );
};
export default PlanSetup;
